<script setup>
  import { ref } from 'vue';
  import FAQs from './faqs.js';
  import Chevron from 'common/icons/Chevron.svg';

  const currentAccordion = ref(-1);

  function toggleAccordion(index) {
    if (index === currentAccordion.value) {
      currentAccordion.value = -1;
      return;
    }

    currentAccordion.value = index;
  }
</script>

<template>
  <div class="frecuentQuestionsCart">
    <div class="fqTitle">Preguntas frecuentes:</div>
    <div class="fqItem" v-for="(fq, index) in FAQs">
      <div
        class="fqItemQuestionContainer"
        @click="() => toggleAccordion(index)"
      >
        <div class="fqQuestion">
          {{ fq.question }}
        </div>
        <div
          class="Chevron-icon"
          :class="{ '--openAccordion': currentAccordion === index }"
          v-html="Chevron"
        ></div>
      </div>
      <transition name="fade">
        <div
          class="fqAnswerContainer"
          v-if="currentAccordion === index"
          v-html="fq.answer"
        />
      </transition>
      <hr class="grayRule bb-mt-5 bb-mb-0" />
    </div>
  </div>
</template>

<style lang="scss">
  @import '~assets/styles/index.scss';

  .FrequentlyAskedQuestions {
    position: relative;
    max-width: 1100px;
    width: 100%;

    @media (max-width: $screen-xs-max) {
      padding: 0 $XXSMALL;
    }
  }

  .frecuentQuestionsCart {
    display: flex;
    flex-direction: column;
    margin: $HUGE auto;
    width: 100%;
    max-width: 720px;
    padding: 0 1em;
  }

  .fqTitle {
    font-size: 20px;
    color: $DARK-GRAY;
    font-weight: bolder;
    margin-bottom: $MINI;
  }

  .fqItem {
    margin-top: $SMALL;
  }

  .grayRule {
    border: 1px solid $GRAY-LIGHT;
    width: 100%;
  }

  .fqItemQuestionContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
  }

  .fqQuestion {
    font-size: 18px;
    color: $DARK-GRAY;

    @media (max-width: $screen-xs-min) {
      font-size: 15px;
    }

    @media (max-width: $screen-xs) {
      font-size: 14px;
    }
  }

  .Chevron-icon {
    transition: 0.4s;
    height: 20px;
    width: 20px;

    ::v-deep svg {
      height: 20px;
      width: 20px;
      cursor: pointer;
      padding: 5px;
      color: $DARK-GRAY;
    }

    &.--openAccordion {
      transform: rotate(-180deg);
    }
  }

  .fqAnswerContainer {
    padding: $SMALL 0;
    font-size: 16px;
    line-height: 23px;

    @media (max-width: $screen-xs-min) {
      font-size: 14px;
    }
  }

  .fqAnswerItem {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: $MINI 0;

    .boxFisicaImg {
      width: 150px;
    }

    .boxDigitalImg {
      width: 80px;
    }

    @media (max-width: $screen-xs) {
      flex-direction: column-reverse;
      align-items: start;

      .boxFisicaImg {
        width: 190px;
      }

      .boxDigitalImg {
        width: 100px;
      }

      &.--mobile {
        align-items: flex-end;
      }

      .fqAnswerItemImg {
        &.--mobileImg {
          transform: translateY(30%);
        }

        &.--mobileImg2 {
          transform: translateY(-60%);
        }
      }
    }
  }

  .fqAnswerIemText {
    font-size: 16px;
    line-height: 23px;

    &.--right {
      margin-left: 20px;
    }

    &.--left {
      margin-right: 20px;
    }

    @media (max-width: $screen-xs-max) {
      font-size: 15px;
    }

    @media (max-width: $screen-xs) {
      &.--right {
        margin-left: 0px;
      }

      &.--left {
        margin-right: 0px;
        transform: translateY(-80%);
      }
    }
  }

  .fade-enter-active {
    transition: opacity 0.8s;
  }

  .fade-leave-active {
    transition: opacity 0.4s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
